import { Component, EventEmitter, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-decline-new-terms-ui',
  templateUrl: './decline-new-terms-ui.component.html',
  styleUrls: ['./decline-new-terms-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class DeclineNewTermsUiComponent {
  @Output()
  backMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  declineMethod: EventEmitter<void> = new EventEmitter();

  back(): void {
    this.backMethod.emit();
  }

  decline(): void {
    this.declineMethod.emit();
  }
}
